import {useQuery} from '@tanstack/react-query';

import {PropertyId} from '../../query/graphql';
import {getCrop} from '../resources/crops';
import {PROPERTIES} from '../resources/properties';
import {getGenericYieldWhenUsedForSimpleCalculators} from './calculations';
import {SimpleCalculatorCrop} from './types';

type Input = {
  propertyId?: PropertyId;
  cropId?: SimpleCalculatorCrop;
};

type Output = {
  annualConsumption?: number;
  inUseMC?: number;
  genericYield?: number;
  cv?: number;
  annualRequirement?: number;
  areaRequired?: number;
  yearsToSelfSufficiency?: string;
  bulkDensity?: number;
  storageSpace?: number;
};

export function calculateSmallScale({propertyId, cropId}: Input): Output {
  const annualConsumption = propertyId ? PROPERTIES[propertyId].annualConsumption : undefined;
  const inUseMC = cropId ? getCrop(cropId).inUseMC : undefined;
  const genericYield = cropId ? getGenericYieldWhenUsedForSimpleCalculators(cropId) : undefined;
  const cv = cropId ? getCrop(cropId).cv : undefined;
  const annualRequirement = annualConsumption !== undefined && cv !== undefined ? annualConsumption / cv : undefined;
  const areaRequired =
    annualRequirement !== undefined && genericYield !== undefined ? annualRequirement / genericYield : undefined;
  const yearsToSelfSufficiency = cropId ? getCrop(cropId).yearsToSelfSufficiency : undefined;
  const bulkDensity = cropId ? getCrop(cropId).bulkDensity : undefined;
  const storageSpace =
    annualRequirement !== undefined && bulkDensity !== undefined ? annualRequirement / bulkDensity : undefined;

  return {
    annualConsumption,
    inUseMC,
    genericYield,
    cv,
    annualRequirement,
    areaRequired,
    yearsToSelfSufficiency,
    bulkDensity,
    storageSpace,
  };
}

export function useSmallScaleCalculator(input: Input) {
  return useQuery({
    queryKey: [input.propertyId, input.cropId],
    queryFn: () => calculateSmallScale(input),
  });
}
